export const Field = ({ label, value, onChange, type = "text", ...rest }) => (
  <div>
    <label className="text-xs tracking-[0.2em] uppercase text-stone-500 block mb-1">{label}</label>
    {type === "textarea" ? (
      <textarea value={value} onChange={onChange} rows={3} className="w-full px-3 py-2 rounded-lg border border-stone-200 focus:border-[#121212] focus:outline-none" {...rest} />
    ) : (
      <input type={type} value={value} onChange={onChange} className="w-full px-3 py-2 rounded-lg border border-stone-200 focus:border-[#121212] focus:outline-none" {...rest} />
    )}
  </div>
);
